import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { SvelteComponent, init, safe_not_equal, empty, insert, group_outros, transition_out, check_outros, transition_in, detach, create_slot, assign, element, set_attributes, update_slot_base, get_all_dirty_from_scope, get_slot_changes, get_spread_update } from '../../node_modules/svelte/internal/index.mjs.js';

function create_if_block_1(ctx) {
  let li;
  let current;
  const default_slot_template = /*#slots*/ctx[3].default;
  const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ctx[2], null);
  let li_levels = [/*attributes*/ctx[1]];
  let li_data = {};
  for (let i = 0; i < li_levels.length; i += 1) {
    li_data = assign(li_data, li_levels[i]);
  }
  return {
    c() {
      li = element("li");
      if (default_slot) default_slot.c();
      set_attributes(li, li_data);
    },
    m(target, anchor) {
      insert(target, li, anchor);
      if (default_slot) {
        default_slot.m(li, null);
      }
      current = true;
    },
    p(ctx, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/4)) {
          update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ctx[2], !current ? get_all_dirty_from_scope( /*$$scope*/ctx[2]) : get_slot_changes(default_slot_template, /*$$scope*/ctx[2], dirty, null), null);
        }
      }
      set_attributes(li, li_data = get_spread_update(li_levels, [dirty & /*attributes*/2 && /*attributes*/ctx[1]]));
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(li);
      if (default_slot) default_slot.d(detaching);
    }
  };
}

// (6:0) { #if tag === 'div' }
function create_if_block(ctx) {
  let div;
  let current;
  const default_slot_template = /*#slots*/ctx[3].default;
  const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ctx[2], null);
  let div_levels = [/*attributes*/ctx[1]];
  let div_data = {};
  for (let i = 0; i < div_levels.length; i += 1) {
    div_data = assign(div_data, div_levels[i]);
  }
  return {
    c() {
      div = element("div");
      if (default_slot) default_slot.c();
      set_attributes(div, div_data);
    },
    m(target, anchor) {
      insert(target, div, anchor);
      if (default_slot) {
        default_slot.m(div, null);
      }
      current = true;
    },
    p(ctx, dirty) {
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope*/4)) {
          update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ctx[2], !current ? get_all_dirty_from_scope( /*$$scope*/ctx[2]) : get_slot_changes(default_slot_template, /*$$scope*/ctx[2], dirty, null), null);
        }
      }
      set_attributes(div, div_data = get_spread_update(div_levels, [dirty & /*attributes*/2 && /*attributes*/ctx[1]]));
    },
    i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d(detaching) {
      if (detaching) detach(div);
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function create_fragment(ctx) {
  let current_block_type_index;
  let if_block;
  let if_block_anchor;
  let current;
  const if_block_creators = [create_if_block, create_if_block_1];
  const if_blocks = [];
  function select_block_type(ctx, dirty) {
    if ( /*tag*/ctx[0] === 'div') return 0;
    if ( /*tag*/ctx[0] === 'li') return 1;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m(target, anchor) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(target, anchor);
      }
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p(ctx, _ref) {
      let [dirty] = _ref;
      let previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, function () {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
            if_block.c();
          } else {
            if_block.p(ctx, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        } else {
          if_block = null;
        }
      }
    },
    i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o(local) {
      transition_out(if_block);
      current = false;
    },
    d(detaching) {
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d(detaching);
      }
      if (detaching) detach(if_block_anchor);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let {
    $$slots: slots = {},
    $$scope
  } = $$props;
  let {
    tag = 'div'
  } = $$props;
  let {
    attributes = null
  } = $$props;
  $$self.$$set = function ($$props) {
    if ('tag' in $$props) $$invalidate(0, tag = $$props.tag);
    if ('attributes' in $$props) $$invalidate(1, attributes = $$props.attributes);
    if ('$$scope' in $$props) $$invalidate(2, $$scope = $$props.$$scope);
  };
  return [tag, attributes, $$scope, slots];
}
let LiOrDiv = /*#__PURE__*/function (_SvelteComponent) {
  function LiOrDiv(options) {
    var _this;
    _classCallCheck(this, LiOrDiv);
    _this = _callSuper(this, LiOrDiv);
    init(_this, options, instance, create_fragment, safe_not_equal, {
      tag: 0,
      attributes: 1
    });
    return _this;
  }
  _inherits(LiOrDiv, _SvelteComponent);
  return _createClass(LiOrDiv);
}(SvelteComponent);

export { LiOrDiv as default };
